// /bot: what BangerVersions is (backend/versions, the update checker) and how to opt out. Its user agent links here:
// "BangerVersions/0.1 (+https://banger.sh/bot; game update checker)".

import { h, link } from "../dom.ts";
import { setTitle } from "../router.ts";

export function botPage(): HTMLElement {
  setTitle("BangerVersions");
  return h(
    "article",
    { class: "copy-page bot" },
    h("h1", null, "BangerVersions"),
    h("p", { class: "lead" }, "BangerVersions is Banger's update checker. It looks at web games listed on Banger to see when they change, so players who follow a game hear about its updates."),
    h("h2", null, "What it reads"),
    h(
      "ul",
      null,
      h("li", null, "The game's own page, and a ", h("code", null, "thrdm.json"), " file next to it if there is one."),
      h("li", null, "Public release feeds: itch.io devlogs and GitHub releases."),
      h("li", null, "It never runs the game or signs in. On your site it stays on the game's own address: a redirect to another site isn't followed."),
    ),
    h("h2", null, "How often"),
    h("p", null, "About every 6 hours per game, hourly for games players hearted in the last week. One request at a time per site, with conditional requests (ETag and Last-Modified), so an unchanged page costs almost nothing."),
    h("h2", null, "Opting out"),
    h("p", null, "BangerVersions follows robots.txt. To keep it away from your site:"),
    h("pre", { class: "code" }, h("code", null, "User-agent: BangerVersions\nDisallow: /")),
    h("p", null, "If it's your game on Banger, you can also ", link("/developers", null, "claim it"), " to control how it's listed, or ask us to remove it from its page."),
  );
}
